// src/app/page.tsx
import { FC } from "react";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import "./index.css";

const PastMemories = (props: {
  setShowConfirmation: (val: boolean) => void;
}) => {
  const pastMemory = () => {
    return (
      <div className="past-memory">
        <Grid container sx={{ width: "100%", alignItems: "center" }}>
          <Grid size={{ xs: 6, md: 6 }}>Old memories</Grid>
          <Grid size={{ xs: 6, md: 6 }} textAlign={"end"}>
            <div className="flex-center">
              <VisibilityOutlinedIcon
                onClick={() => props.setShowConfirmation(true)}
                color="secondary"
                className="c-pointer"
              />
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };
  return (
    <div className="pastmemories-section">
      <Typography>Past memories</Typography>
      <Grid container className="pastmemories-container">
        <Grid size={{ xs: 12, md: 12 }}>{pastMemory()}</Grid>
        <Grid size={{ xs: 12, md: 12 }}>{pastMemory()}</Grid>
        <Grid size={{ xs: 12, md: 12 }}>{pastMemory()}</Grid>
      </Grid>
    </div>
  );
};

export default PastMemories;
